/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TwoDWaterRaster } from "./TwoDWaterRaster";
import {
  TwoDWaterRasterFromJSON,
  TwoDWaterRasterFromJSONTyped,
  TwoDWaterRasterToJSON,
  TwoDWaterRasterToJSONTyped,
} from "./TwoDWaterRaster";

/**
 *
 * @export
 * @interface PaginatedTwoDWaterRasterList
 */
export interface PaginatedTwoDWaterRasterList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<TwoDWaterRaster>;
}

/**
 * Check if a given object implements the PaginatedTwoDWaterRasterList interface.
 */
export function instanceOfPaginatedTwoDWaterRasterList(
  value: object
): value is PaginatedTwoDWaterRasterList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedTwoDWaterRasterListFromJSON(json: any): PaginatedTwoDWaterRasterList {
  return PaginatedTwoDWaterRasterListFromJSONTyped(json, false);
}

export function PaginatedTwoDWaterRasterListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedTwoDWaterRasterList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(TwoDWaterRasterFromJSON),
  };
}

export function PaginatedTwoDWaterRasterListToJSON(json: any): PaginatedTwoDWaterRasterList {
  return PaginatedTwoDWaterRasterListToJSONTyped(json, false);
}

export function PaginatedTwoDWaterRasterListToJSONTyped(
  value?: PaginatedTwoDWaterRasterList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(TwoDWaterRasterToJSON),
  };
}
